module.exports = __webpack_public_path__ + "img/Home-1.c1c7c730.jpg";